import { FormControl } from '@angular/forms';
import { AutomatedLogbookData } from './automated-logbook-data.model';

export class AutomatedLogbookDataForm {
  automatedNightFlightMinutes: FormControl;
  automatedHoldTime: FormControl;
  automatedNightTakeoffs: FormControl;
  automatedDayTakeoffs: FormControl;
  automatedNightLandings: FormControl;
  automatedDayLandings: FormControl;

  // index signature
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(automatedData?: AutomatedLogbookData) {
    if (automatedData) {
      this.automatedNightFlightMinutes = new FormControl(automatedData.automatedNightFlightMinutes);
      this.automatedHoldTime = new FormControl(automatedData.automatedHoldTime);
      this.automatedNightTakeoffs = new FormControl(automatedData.automatedNightTakeoffs);
      this.automatedDayTakeoffs = new FormControl(automatedData.automatedDayTakeoffs);
      this.automatedNightLandings = new FormControl(automatedData.automatedNightLandings);
      this.automatedDayLandings = new FormControl(automatedData.automatedDayLandings);
    }
  }
}
